<template>
  <div class="sim-api-demo">
    <h2>
      sim
    </h2>
    <div class="input-words-wrapper">
      <input
        type="text"
        v-model="input"
        class="input-text"
        @keyup.13="onEnter"
      >
      <input
        type="text"
        v-model="words[i]"
        v-for="word,i in words"
        :key="i"
        class="input-text"
        @keyup="onWordsKeyup(word, i, $event)"
      >
    </div>
    <br>
    <v-btn @click="paste">
      貼上
    </v-btn>
    <v-btn @click="submit()">
      送出
    </v-btn>
    <v-btn @click="clear()">
      清除所有例句
    </v-btn>
    <br>
    <br>
    <br>
    <table class="sim-words">
      <tr v-for="word, i in last.words" :key="i">
        <td>
          #{{i}}
        </td>
        <td :title="word">
          {{word.substr(0, 15)}}
          {{word.length > 15 ? '...' : ''}}
        </td>
      </tr>
    </table>
    <br>
    <br>
    <table class="sim-matrix">
      <tr>
        <td>*</td>
        <td v-for="row, i in last.table" :key="i" :title="last.words[i]">
          #{{i}}
        </td>
      </tr>
      <tr v-for="row, i in last.table" :key="i" :title="last.words[i]">
        <td>
          #{{i}}
        </td>
        <td v-for="s, j in row" :key="j" :title="last.words[i] + '  &  ' + last.words[j]">
          {{s.toFixed(2)}}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import $ from 'jquery'
import { getSim } from '@/lib/nlp-api'

export default {
  name: 'SimApiDemo',
  data () {
    return {
      input: '',
      words: [],
      deleteLock: {},
      last: {
        words: [],
        table: []
      },
      loadding: false
    }
  },
  methods: {
    onWordsKeyup (word, i, e) {
      if (e.key === 'Backspace' || e.key === 'Delete') {
        if (word.length === 0) {
          if (this.deleteLock[i]) {
            this.deleteLock[i] = false
            this.words.splice(i, 1)
          } else {
            this.deleteLock[i] = true
          }
        }
      }
    },
    onEnter (e) {
      if (e.ctrlKey) {
        if (this.input) {
          this.addWord()
        }
        this.submit()
      } else {
        this.addWord()
      }
    },
    addWord (word = null) {
      if (!word && this.input) {
        word = this.input
        this.input = ''
      } else if (!word && !this.input) {
        return
      }
      this.words.push(word)
    },
    readBlob (blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = (e) => {
          resolve(e.target.result)
        }
        reader.readAsText(blob)
      })
    },
    async paste () {
      /**
       * @type {ClipboardItem[]}
       */
      const items = await navigator.clipboard.read()
      for (const i in items) {
        const item = items[i]
        if (item.types.includes('text/html')) {
          const htmlFile = await item.getType('text/html')
          const htmlText = await this.readBlob(htmlFile)
          const htmlDoc = $.parseHTML(htmlText)
          console.log(htmlDoc)
          $(htmlDoc).find('td').each((i, e) => {
            const text = $(e).text().trim()
            if (text) {
              console.log('text:', text)
              this.words.push(text)
            }
          })
          // console.log('text', htmlText)
        } else if (item.types.includes('text/plain')) {
          const blob = await item.getType('text/plain')
          const text = (await this.readBlob(blob)).trim()
          const arr = text.split('\n')
          for (const w of arr) {
            this.words.push(w)
          }
        }
      }
      console.log(items)
    },
    clear () {
      this.words = []
    },
    async submit () {
      if (this.loadding) return
      this.loadding = true
      const words = [...this.words].filter((item) => !!item)
      this.last.words = words
      try {
        if (words.length > 1) {
          const simMatrix = await getSim(words)
          this.last.table = simMatrix
        }
      } catch (e) {
        console.error(e)
      }
      this.loadding = false
    }
  }
}
</script>

<style scoped>
.sim-api-demo{
  text-align: center;
}
.input-text{
  border: 1px solid black;
  padding: 4px;
}
.input-words-wrapper{
  display: inline-flex;
  flex-direction: column;
  max-width: 200px;
  padding: 8px;
  justify-content: center;
  align-items: center;
}
.sim-matrix,.sim-words{
  display: inline-table;
  border-collapse: collapse;
}
.sim-words td{
  border: 1px solid black;
  padding: 2px;
}
.sim-matrix td{
  border: 1px solid black;
  padding: 2px;
}
button:hover{
  opacity: 0.8;
}
</style>
